import styled from 'styled-components';

import CheckboxPattern from '@mlb/react-patterns/components/Checkbox/checkbox';

export const Checkbox = styled(CheckboxPattern)`
    display: inline-flex;
    margin-bottom: 15px;
`;

export const OptionsWrapper = styled.div`
    ${({ columnCount, theme }) => {

        if(columnCount > 0) {

            return `
                display: block;
                column-count: ${columnCount};
                column-gap: ${theme.filter?.columnGap};

                ${Checkbox} {
                    width: 100%;
                    break-inside: avoid;
                }
            `;

        } else {

            return `
                display: flex;
                flex-wrap: wrap;

                ${Checkbox} {
                    margin-right: 10px;
                    justify-content: center;
                }
            `;

        }

    }}
`;
